'use strict';

module.exports = one;

function one(node, parent) {
  var self = this;
  var visitors = self.visitors;

  /* Fail on unknown nodes. */
  if (typeof visitors[node.type] !== 'function') {
    self.file.fail(
      new Error(
        'Missing compiler for node of type `' +
        node.type + '`: `' + node + '`'
      ),
      node
    );
  }

  return visitors[node.type].call(self, node, parent);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/macro/one.js
// module id = 953
// module chunks = 95715928098905 168707334958949